// extracted by mini-css-extract-plugin
export default {"Loader":"spinner_Loader__xxbgo","load8":"spinner_load8__FrZay"};